export const moduleName = 'websocket';

export default {
  LISTENING_FROM_SOCKET_DATA: `${moduleName}/LISTENING_FROM_SOCKET_DATA`,
};
